<template>
	<div class="content-pad-vert content-pad-horizontal">
		<v-layout row wrap class="pa-0">
			<v-flex x12 sm10 md8 offset-sm1 offset-md2 class="pa-0 text-xs-center">
				<h1 class="mb-5">Events you're attending</h1>
				<div
					style="color: #999"
					v-if="getAttendingEvents.length == 0"
				>
					<p class="text-xs-center">
						Hello!  Please check back here after you RSVP for at least one event.
					</p>
					<p class="text-xs-center">
						This is where you can view all of your existing event RSVPs!
					</p>
				</div>
				<div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
					<div class="attending-events__event-tile-flex mt-3" v-for="event in getAttendingEvents" :key="event.pk">
						<event-list-item :event="event"></event-list-item>
					</div>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EventListItem from '~/components/EventListItem.vue'

export default {
	methods: {
		...mapActions(['setModalOpen'])
	},
	computed: {
		...mapGetters(['getAllEvents', 'user']),
		getAttendingEvents() {
			let events = this.getAllEvents
			let attendedEvents = []
			for (var i = 0; i < events.length; i++) {
				if (events[i].attendees.indexOf(this.user.uuid) > -1) {
					attendedEvents.push(events[i])
				}
			}
			return attendedEvents
		}
	},
	components: {
		EventListItem
	}
}
</script>

<style>
.attending-events__event-tile-flex {
	width: 48%;
	height: 350px;
	margin-bottom: 60px;
}

/* lg */
@media screen and (max-width: 1920px) {
	.attending-events__event-tile-flex {
		height: 300px;
	}
}

/* md */
@media screen and (max-width: 1280px) {
	.attending-events__event-tile-flex {
		height: 250px;
	}
}

/* sm */
@media screen and (max-width: 960px) {
	.attending-events__event-tile-flex {
		height: 300px;
		width: 100%;
	}
}

/* xs */
@media screen and (max-width: 599px) {
	.attending-events__event-tile-flex {
		width: 100%;
		height: 300px;
	}
}
</style>
